<template>
  <s-section
    :class="['section values', {'values--darkness' : isDarkness}]"
    :title="values.title"
    :subtitle="values.subtitle"
    :type="isDarkness ? 'inverse' : ''"
  >
    <template v-if="values.items.length !== 4">
      <div class="row">
        <div class="col-xl-9 ml-auto">
          <div class="values__grid">
            <div
              v-for="(item, index) in values.items"
              :key="item.id"
            >
              <values-item
                :item="item"
                :index="index + 1"
                :is-numbered="isNumbered"
              ></values-item>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="values__grid values__grid--full">
        <div
          v-for="(item, index) in values.items"
          :key="item.id"
        >
          <values-item
            :item="item"
            :index="index + 1"
            :is-numbered="isNumbered"
          ></values-item>
        </div>
      </div>
    </template>
  </s-section>
</template>

<script>
import ValuesItem from './ValuesItem'

export default {
  name: 'Values',
  components: {
    ValuesItem
  },
  props: {
    values: {
      type: Object,
      default() {
        return {}
      }
    },
    isNumbered: {
      type: Boolean,
      default: false
    },
    isDarkness: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.values {
  &--darkness {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.values__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 64px 16px;

  @media (max-width: $breakpoint-md) {
    grid-template-columns: 1fr;
  }
}

.values__grid--full {
  grid-template-columns: repeat(4, 1fr);

  @media (max-width: $breakpoint-lg) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: $breakpoint-md) {
    grid-template-columns: 1fr;
  }
}
</style>